/**
 * DV-313: cash is no longer an accepted payment method.
 *
 * Compliance requires every purchase to go through a tracked electronic payment, so the product
 * must stop recording cash. Square becomes the only way to take money for a ticket.
 *
 * The cash code paths are left in place behind this flag rather than deleted, as with
 * TICKET_TRANSFER_ENABLED: this is a compliance decision and may be revisited. Setting this to
 * true alone will not bring cash back — the backend answers a cash purchase with 410 Gone
 * regardless of what the admin app sends.
 *
 * What this does NOT touch, deliberately:
 *   - cash taken before this change keeps its CASH_PAYMENT status and still counts as revenue
 *   - the Cash Tracker stays, read-only, so volunteers can still reconcile cash they hold
 *   - refunds of past cash sales still work; there is no electronic payment to reverse instead
 */
export const CASH_PAYMENTS_ENABLED = false;
